<template>

  <b-container fluid class="h-100 wrapper">
      <b-row class="h-100 justify-content-center align-items-center">
        <b-col cols="4"  class="loginform">

          <div class="formContainer">

            <div v-if="!showPasswordSet">
              <span class="title" v-if="isInvitePage">Set initial password for account</span>
              <span class="title" v-else>Set new password for account</span>

              <b-form>
                <b-form-group id="input-group-password" label="Password:" label-for="input-2">
                  <b-form-input id="user-password" v-model="password" type="password" placeholder="Enter password"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-password-repeat" label="Repeat password:" label-for="input-2">
                  <b-form-input id="user-repeat-password" v-model="repeatPassword" type="password" placeholder="Enter password" :state="passwordValidation"></b-form-input>
                  <b-form-invalid-feedback class="invalid-feedback" :state="passwordValidation">Passwords mismatch</b-form-invalid-feedback>
                </b-form-group>

                <b-alert v-if="showPasswordError" show>'PASSWORD_RULES'</b-alert>
                <b-alert v-if="showTokenError" show>Token error!</b-alert>

                <b-button :disabled="!passwordValidation || passwordEmpty" @click="onSetPassword" variant="primary">Set new password</b-button>

              </b-form>
            </div>

            <div v-else>
              <div class="title">Password has been set</div>
              <b-link href="/" class="loginLink">Goto login</b-link>
            </div>

          </div>


        </b-col>
      </b-row>

    </b-container>


</template>

<script>
import AuthService from "../../services/AuthService";

export default {
  name: 'NewPasswordPage',

  data() {
    return {
        setPasswordResult: null,
        password: '',
        repeatPassword: ''
      }
  },

  computed: {
    isInvitePage() {
      return this.$router.currentRoute.name==='invite'
    },

    passwordValidation() {
      return this.repeatPassword===this.password
    },

    passwordEmpty() {
      return this.repeatPassword.length===0
    },

    showPasswordError() {
      return this.setPasswordResult!=null && this.setPasswordResult.result===1
    },

    showTokenError() {
      return this.setPasswordResult!=null && this.setPasswordResult.result===2
    },

    showPasswordSet() {
      return this.setPasswordResult!=null && this.setPasswordResult.result===0
    }


  },

  methods: {

    onSetPassword() {
      let token = this.$route.params.resetToken

      if(!token) {
        token = this.$route.params.inviteToken
      }

      AuthService.setPassword(token, this.repeatPassword).then((response) => {
        this.setPasswordResult = response.data;
      })

    },

  }

}
</script>

<style scoped>
  .wrapper {
    background-color: white;
    background-image: url('../../assets/waves_nocert.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right bottom;
  }

  .buttonContainer {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  .title {
    font-size: 1.5em;
    text-align: center;
    margin-bottom: 1em;

  }

  .maixname {
    color: #30bcff;
  }

  .formContainer {
    background-color: #65686a;
    color: white;
    padding: 1em;
  }


  .loginButton {
    background-color: #30bcff;
    border-color: #30bcff;
  }

  .invalid-feedback, .loginLink {
    color: white;
  }


</style>
